import { AuthClientInitOptions } from 'services/auth/keycloak/core';

export const initOptions: AuthClientInitOptions = {
  onLoad: 'login-required',
  checkLoginIframe: false,
};
